<template>
  <div>
    <div class="pricing-container">
      <div class="pricing-container__left">
        <div class="pricing-box">
          <h2>Skolens samlede elevtal</h2>
          <p>Betal for skolens samlede elevtal - og få et ubegrænset antal brugere på</p>
          <h3>5<span class="text-grey" style="font-size: 16px">kr</span></h3>
          <p>pr. elev / måned
            <p>+ 499 kr pr. måned i licens pr. institution<br>
              <span class="font-small">Alle priser er eksklusiv moms</span>
            </p>
          </p>
        </div>
      </div>

      <div class="pricing-container__right">
        <h2>En stærk samlet pakke til jeres skole</h2>
        <ul class="pricing-features">
          <li v-for="feature in features"><span class="icon-checkmark4 color-blue"></span> {{ feature }}</li>
          <li>... og meget mere</li>
        </ul>
        <h4>Betaling hver måned eller årligt</h4>
        <p>I bestemmer selv, om I vil faktureres hver måned eller hvert år</p>
        <h4>Prøv gratis i 30 dage</h4>
        <p>Du kan prøve Docendo i 30 dage helt gratis. Du binder dig ikke til at købe systemet, og vi beder ikke
          om dine kontooplysninger.
          Efter 30 dage bestemmer du selv, om du vil fortsætte med Docendo.
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      features: ['Automatisk skemalægning', 'Fleksibel skemalægning', 'Vikardækning', 'Arbejdstidsregistering', 'Årsnorm/Tjenestetid', 'Fagfordeling', 'Opgave- og aktivitetsoversigt', 'Ugeplan', 'Integration med Uni-C (Uni-Login), Aula, Google, Outlook m.m', 'Aula widgets: Dagens Vikarer & Ugeplan', 'Import af fag fra Undervisningsministeriet', 'Grundskole- og kompetenceindberetning', 'Support', 'Evt. Import af jeres nuværende skemaer']
    }
  }
}
</script>

<style scoped>
@import "../../assets/css/variables.css";

.pricing-container {
  display: flex;
  gap: 80px;
  line-height: 1.4;
  font-family: Avenir, helvetica neue, helvetica, arial !important;
  font-size: 16px;
  margin-top: 40px;
  background: #f5f7f9;
  padding: 20px;
}

.pricing-container__right {
  flex: 2;
}

.pricing-container p {
  margin: 10px 0;
}

.pricing-box {
  background: #fff;
  padding: 20px 20px 50px;
  border: 1px solid #e7e7e7;
  border-radius: 4px;
  text-align: center;
  max-width: 360px;
}

.pricing-box h3 {
  margin: 0;
  font-size: 84px;
  color: var(--purple);
}

.color-blue {
  color: var(--purple);
}

.pricing-features {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  margin-bottom: 2rem;
}

.pricing-features > li {
  display: flex;
  align-content: center;
  gap: 1rem;
  line-height: 1;
}

.pricing-container__right h2 {
  margin-bottom: 1rem;
}

</style>



// WEBPACK FOOTER //
// Pricing.vue?57443278